import { monogramInitials, publicAvatarDescription } from "@/lib/avatarUi";

// Universal avatar visual (FR22 / Story 5.5): renders the AI portrait when
// `foto_url` exists, otherwise a two-initial monogram (Bricolage, brand.ink2
// on brand.elevated) — replacing the deterministic av1-6 PNGs. Also owns the
// "gerando" shimmer state so cards and the review share one implementation.
export default function AvatarMedia({
  avatar,
  peerAvatars,
  aspectClass = "aspect-[4/5]",
  roundedClass = "rounded-xl",
  monogramClass = "text-[64px]",
  gradient = false,
  generating = false,
  className = "",
  testid = "avatar-media",
}) {
  const foto = avatar?.foto_url;
  const publicDescription = publicAvatarDescription(avatar, peerAvatars);
  const initials = monogramInitials(publicDescription);

  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden bg-brand-elevated ${aspectClass} ${roundedClass} ${className}`}
    >
      {generating ? (
        <div
          data-testid="avatar-media-generating"
          aria-busy="true"
          className="absolute inset-0 flex items-center justify-center"
        >
          <div
            className="animate-shimmer-pink absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(100deg, #1A141F 30%, rgba(161,107,247,0.22) 50%, #1A141F 70%)",
              backgroundSize: "200% 100%",
            }}
          />
          <div className="relative flex flex-col items-center gap-2 text-brand-ink2">
            <span className="w-2 h-2 rounded-full bg-brand-rose animate-pulse" />
            <span className="text-[11px] font-ui tracking-wide">gerando retrato…</span>
          </div>
        </div>
      ) : foto ? (
        <img
          src={foto}
          alt={`Retrato do público: ${publicDescription}`}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      ) : (
        <div
          data-testid="avatar-monogram"
          className="w-full h-full flex items-center justify-center"
        >
          <span className={`font-display leading-none text-brand-ink2 ${monogramClass}`}>
            {initials}
          </span>
        </div>
      )}

      {gradient && !generating && (
        <div
          aria-hidden="true"
          className="absolute inset-x-0 bottom-0 h-2/5 pointer-events-none"
          style={{
            background:
              "linear-gradient(to top, rgba(10,8,16,0.85) 0%, rgba(10,8,16,0) 100%)",
          }}
        />
      )}
    </div>
  );
}
